import { MapTo } from '@adobe/cq-react-editable-components';
import React, { Component } from 'react';
import SPAXFHeader from './SPAXFHeader';

class SPAXFHeaderWrapper extends Component {
  props: any;

  render(): JSX.Element {
    return (
      <div>
        <SPAXFHeader />
      </div>
    );
  }
}

export default MapTo('workplace-spa/components/spaxfheader')(SPAXFHeaderWrapper);
